module.exports = __webpack_public_path__ + "static/media/historyIphoneSmall.4c160262.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/historyIphoneSmall.png
// module id = 657
// module chunks = 0